import '.g2{border-left:4px solid var(--gray-200);}.ssr-plugin'
import '.g3{padding-left:1.5rem;}.ssr-plugin'
import '.g4{margin:1rem 0;}.ssr-plugin'
import '.g5{color:var(--gray-700);}.ssr-plugin'
import '.g6{font-style:italic;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { PropsWithChildren } from 'react'

interface BlockQuoteProps extends PropsWithChildren {
  style?: Style
}

export const BlockQuote = ({ children, style }: BlockQuoteProps) => {
  return (
    <styled.blockquote className="g2 g3 g4 g5 g6"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.blockquote>
  )
}
